let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7snhF"), load("X0Jic"), load("bAoKR"), load("34YSq"), load("5IaSN")]).then(() => parcelRequire('kVRsY'));